<template>
    <div class="OpenInAppBarAppInfoWrap">
        <div class="OpenInAppBarWrap">
            <div class="OpenInAppBarWrap_content">
                <h1 class="OpenInAppBarWrap_title"><i></i>{{ title }}</h1>
                <button type="button" class="OpenInAppBarWrap_btnOpen" @click="$emit('open')">
                    立即打开微信小程序
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeMiniProgramBar',
    props: {
        title: {
            type: String,
            default: '安居客专享特价房源'
        }
    }
};
</script>

<style scoped src="@ajk/touch-vue-components/src/components/biz-app-download-bar/biz-app-download-bar.css"></style>
